import { AfterViewInit, Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { BaseServiceService } from "src/app/services/base-service.service";

@Component({
  selector: "app-permisos-menu",
  templateUrl: "./permisos-menu.component.html",
  styleUrl: "./permisos-menu.component.css",
})
export class PermisosMenuComponent implements OnInit, AfterViewInit {
  dtOptions: DataTables.Settings = {};
  
  @ViewChild(DataTableDirective, { static: false })
  dtElement: any;
  dtInstance: DataTables.Api;
  dtOptButtons: any = [];
  getDataTableMenu: any = ["Menu", "GetDataTableMenu"];

  columnas = [
    { title: "Menu", data: "Nombre" },
    { title: "Descripción", data: "Descripcion" }
  ];

  columnasPersonalizadas = [
    { title: "Icono", data: "iconName", columnType: "icon", dataType: "json", propertyData: "Configuracion" }
  ];




  constructor(private renderer: Renderer2,
    private router: Router,
    private baseService : BaseServiceService

  ) {}

  ngOnInit(): void {

    this.dtOptButtons.push({'button-id': 'btnAñadirUsuario', 'button-icon': 'ms-Icon--FollowUser', "button-tooltip": "Permisos" });
    
  }

  ngAfterViewInit(): void {
  }

  attachClickEvents(): void {
    const añadirUsuarioButton = document.querySelectorAll("#btnAñadirUsuario");

    añadirUsuarioButton.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const grupoId = button.getAttribute("data-id");
        this.baseService.exportIdOpcionMenu(grupoId);
        this.baseService.exportIsOptionMenu(true);
        this.abrirUsuariosPermitidos();
      });
    });
  }

  gridLoaded(event: any)
  {
    this.dtInstance = event['table'];
  }

  customClick(event: any)
  {
    try {
      
      switch(event['button-id'])
      {
        case 'btnAñadirUsuario':
          const grupoId = event["data-id"];
          this.baseService.exportIdOpcionMenu(grupoId);
          this.baseService.exportIsOptionMenu(true);
          this.abrirUsuariosPermitidos();
          
          break;
      }
      
    } catch (error) {
      console.error("Error al retornar evento datatable", error);
    }
  }


  abrirUsuariosPermitidos() {
    this.router.navigate(["home/acceso"]);

  }
}
